import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
// import './index.css'
import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate } from '@azure/msal-react';
import { BrowserRouter as Router } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { createTheme, MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { QueryClient, QueryClientProvider } from 'react-query';

import { msalInstance } from './auth';
import '@mantine/core/styles.css';
import 'mantine-datatable/styles.layer.css';
import '@mantine/dates/styles.css';
import '@mantine/charts/styles.css';
import '@mantine/notifications/styles.css';
import 'mantine-react-table/styles.css';
import Login from './Auth/Login';

const queryClient = new QueryClient();

const theme = createTheme({
	primaryColor: 'indigo',
	fontFamily: 'system-ui, Avenir, Helvetica, Arial, Nunito, sans-serif', 
	headings: { 
		fontFamily: 'system-ui, Avenir, Helvetica, Arial, Nunito, sans-serif' 
	},
	components: {
		Button: {
			defaultProps: {
				radius: "sm",
			}
		},
		Select: {
			defaultProps: {
				comboboxProps: {
					shadow: "xl", 
					offset: 1
				}
			}
		},
		MultiSelect: {
			defaultProps: {
				comboboxProps: {
					shadow: "xl", 
					offset: 1
				}
			}
		},
		DatePickerInput: {
			defaultProps: {
				popoverProps: {
					shadow: "xl", 
					offset: 1
				}
			}
		},
		Autocomplete: {
			defaultProps: {
				comboboxProps:{
					shadow: "xl", 
					offset: 1
				} 
			}
		},
		Modal: {
			defaultProps: {
				radius: "md",
			}
		}
	}
});

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_KEY);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
	 <MsalProvider instance={msalInstance}>
		<Router>
			<MantineProvider defaultColorScheme="dark" theme={theme}>
				<Notifications position="top-right" />
				<ModalsProvider>
					<QueryClientProvider client={queryClient}>
						<AuthenticatedTemplate>
							<Elements stripe={stripePromise}>
								<App />
							</Elements>
						</AuthenticatedTemplate>
						<UnauthenticatedTemplate>
							<Login />
						</UnauthenticatedTemplate>
					</QueryClientProvider>

				</ModalsProvider>
			</MantineProvider>
		</Router>
	 </MsalProvider>
  </React.StrictMode>,
)
